export default "__VITE_ASSET__DYR1v37C__"